import { tenantSession, TOOLS_PATH } from '../Auth/session';
const API = tenantSession.api;
const toolPath = path => `${TOOLS_PATH}/${path.replace(/^\//, '')}`;

const postData = (path, data) => {
  return API.post(toolPath(path), data, {
      headers: {
        "Content-Type": "application/json"
      }
    });
};

const postImage = (path, formData) => {
  return API.post(toolPath(path), formData, {
      responseType: "blob",
      headers: {
         'Content-Type': 'multipart/form-data'
      }
    });
};

const postFormData = (path, formData) => {
  return API.post(toolPath(path), formData, {
      headers: {
         'Content-Type': 'multipart/form-data'
      }
    });
};



const getData = (path) => {
  return API.get(toolPath(path) , {
    headers: {
        "Content-Type": "application/json"
      }
  });
}

export const Beautify = (data) =>  {
  return postData("json/beautify", data);
};

export const getTimezones = () => {
  return getData("/time/timezones");
}




export const ValidateJSON = (data) => postData("json/validate", data);
export const Minify = (data) => postData("json/minify", data);
export const JSONtoYAML = (data) => postData("json/json-to-yaml", data);
export const YAMLtoJSON = (data) => postData("json/yaml-to-json", data);
export const JSONtoCSV = (data) => postData("json/json-to-csv", data);
export const CSVtoJSON = (data) => postData("json/csv-to-json", data);
export const JSONtoXML = (data) => postData("json/json-to-xml", data);
export const XMLtoJSON = (data) => postData("json/xml-to-json", data);
export const JSONtoQP = (data) => postData("json/json-to-query", data);
export const QPtoJSON = (data) => postData("json/query-to-json", data);
export const JSONDiff = (data) => postData("json/diff", data);
export const JSONMultiDiffAPI = (data)=>postData("json/multi-diff", data);
export const JSONTreeAPI = (data) => postData("json/tree", data);
export const JSONPathAPI = (data) => postData("json/jsonpath", data);
export const Base64Encode = (data) => postData("encode-decode/base64/encode", data);
export const Base64Decode = (data) => postData("encode-decode/base64/decode", data);
export const Base64URLEncode = (data) => postData("encode-decode/base64url/encode", data);
export const Base64URLDecode = (data) => postData("encode-decode/base64url/decode", data);
export const URLEncode = (data) => postData("encode-decode/url/encode", data);
export const URLDecode = (data) => postData("encode-decode/url/decode", data);
export const HexEncode = (data) => postData("encode-decode/hex/encode", data);
export const HexDecode = (data) => postData("encode-decode/hex/decode", data);
export const HTMLEncode = (data) => postData("encode-decode/html/encode", data);
export const HTMLDecode = (data) => postData("encode-decode/html/decode", data);
export const QuotedPrintableEncode = (data) => postData("encode-decode/quoted-printable/encode", data);
export const QuotedPrintableDecode = (data) => postData("encode-decode/quoted-printable/decode", data);
export const ASCIIEncode = (data) => postData("encode-decode/ascii/encode", data);
export const ASCIIDecode = (data) => postData("encode-decode/ascii/decode", data);
export const HMACGenerate = (data) => postData(`crypto/hmac/generate`, data);
export const HMACVerify = (data) => postData(`crypto/hmac/verify`, data);
export const HashCompute = (data, algo) => postData(`crypto/${algo}`, data);
export const Argon2SaltGenerate = () => postData("crypto/argon2/salt");
export const Argon2HashGenerate = (data) => postData("crypto/argon2/hash", data);
export const Argon2HashVerify = (data) => postData("crypto/argon2/verify", data);
export const JWTEncode = (data) => postData("crypto/jwt/encode", data);
export const JWTDecode = (data) => postData("crypto/jwt/decode", data);
export const JWTVerify = (data) => postData("crypto/jwt/verify", data);
export const BcryptHashGenerate = (data) => postData("crypto/bcrypt/hash", data);
export const BcryptHashVerify = (data) => postData("crypto/bcrypt/verify", data);
export const CaseConvertAPI = (data) => postData("text/case", data);
export const EscapeText = (data) => postData("text/escape", data);
export const UnescapeText = (data) => postData("text/unescape", data);
export const WhitespaceTrimAPI = (data) => postData("text/whitespace", data);
export const LoremIpsumAPI = (data) => postData("text/lorem", data);
export const UUIDGenerateAPI = (data) => postData("text/uuid", data);
export const CharCountAPI = (data) => postData("text/count", data);
export const ColorPickerAPI = (data) => postData("text/color/convert", data);
export const RandomStringAPI = (data) => postData("text/random-string", data);
export const FindReplaceAPI = (data) => postData("text/regex/replace", data);
export const RegexTestAPI = (data) => postData("text/regex/test", data);
export const XMLFormat = (data) => postData("xml/format", data);
export const XMLMinify = (data) => postData("xml/format/minify", data);
export const HTMLformat = (data) => postData("xml/format/html", data);
export const HTMLStripperAPI = (data) => postData("xml/format/html-to-text", data);
export const MarkdowntoHTMLAPI = (data) => postData("xml/format/markdown-to-html", data);
export const CSVtoSQL = (data) => postData("DBTools/csv-to-sql-insert", data);
export const JSONtoSQL = (data) => postData("DBTools/json-to-sql-insert", data);
export const Crongenerate = (data) => postData("time/cron/generate", data);
export const Cronparse = (data) => postData("time/cron/parse", data);
export const TimezoneConvert = (data) => postData("time/timezone/convert", data);
export const TimeDifference = (data) => postData("time/diff", data);
export const TimeStampConvert = (data) => postData("time/timestamp/convert", data);
export const TextDiffAPI = (data) => postData("diff/text-diff", data);
export const XmlDiffAPI = (data) => postData("diff/xml-diff", data);
export const CsvDiffAPI = (data) => postData("diff/csv-diff", data);
export const PdftoImageAPI = (data) => postData("imgpdf/pdf-to-image", data);
export const ImagetoPDFAPI = (data) => postData("imgpdf/image-to-pdf", data);
export const PDFMergerAPI = (data) => postData("imgpdf/merge-pdfs", data);
export const PDFSplitterAPI = (data) => postData("imgpdf/split-pdf", data);
export const DocxtoPDFAPI = (formData) => postImage("imgpdf/docx-to-pdf", formData);
export const DocxtoMarkDownAPI = (formData) => postFormData("imgpdf/docx-to-md", formData);

export const ImageConverterAPI = (formData) => postImage("imgpdf/convert", formData);
export const ImagetoBase64API = (formData) => postImage("imgpdf/image-to-base64", formData);
export const Base64toImageAPI = (formData) => postData("imgpdf/base64-to-image/base64", formData);
